import { CompanyEntity } from 'shared/domain/company/types/entity';
import { ContractModel } from 'shared/domain/contract/types/model';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { ContractEntity } from 'serviceWorker/repository/contract/entity';
import { contractEntityToModel } from 'serviceWorker/repository/contract/mapping';
import { getCompaniesByIds } from 'serviceWorker/services/companies';
import { getUsersSynchronized } from 'serviceWorker/services/users/getUsers';
import * as dbContracts from '../../db/contracts/contracts';
import * as dbContractsService from '../../db/contracts/contractsService';
import { contractChannelContract } from 'shared/domain/contract/contractChannelContract';
import { makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

const getAllContractPartiesIds = function (
  contractEntities: ContractEntity[]
): string[] {
  const result: string[] = [];
  contractEntities.forEach((contractEntity) =>
    contractEntity.parties.forEach((party) => result.push(party.companyId))
  );
  return result;
};

export async function getAllContractPartyEntities(
  contractEntities: ContractEntity[]
): Promise<CompanyEntity[]> {
  const allContractPartiesIds = getAllContractPartiesIds(contractEntities);
  return getCompaniesByIds(allContractPartiesIds);
}

/** Every contract of IndexedDB as a model, with its parties' labels; read once the contracts are downloaded. */
async function readContractModels(): Promise<ContractModel[]> {
  const contractEntities = await dbContracts.get();
  const [allContractPartiesEntities, users] = await Promise.all([
    getAllContractPartyEntities(contractEntities),
    getUsersSynchronized(),
  ]);
  return contractEntities.map((contractEntity) =>
    contractEntityToModel(contractEntity, allContractPartiesEntities, users)
  );
}

export const getAndBroadcastAllContracts = makeLoadedEventPublisher(
  contractChannelContract,
  DomainMessagesTypes.allContracts,
  () => readCollectionPayload(dbContractsService, readContractModels)
);
